import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";
import { submitConsultation } from "@/lib/api";

const inputCls =
  "w-full rounded-xl border border-gold/20 bg-navy-850/80 px-4 py-3.5 text-sm text-slate-100 outline-none transition-colors placeholder:text-slate-500 focus:border-gold/60";

const COUNTRIES = ["آمریکا", "کانادا", "استرالیا", "حوزه شنگن", "هنوز مطمئن نیستم"];
const VISA_TYPES = ["پناهندگی و ویزای بشر دوستانه (کیس مسیحیت)", "پناهندگی سیاسی", "ویزای کاری", "هنوز نمی‌دانم — راهنمایی می‌خواهم"];

export default function ConsultationForm() {
  const [form, setForm] = useState({ name: "", phone: "", email: "", country: COUNTRIES[0], visaType: VISA_TYPES[0], message: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await submitConsultation(form);
      toast.success(res.data.message || "درخواست شما ثبت شد.");
      setForm({ name: "", phone: "", email: "", country: COUNTRIES[0], visaType: VISA_TYPES[0], message: "" });
    } catch {
      toast.error("ارسال فرم ناموفق بود؛ لطفاً دوباره تلاش کنید.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="consultation-form">
      <div className="grid gap-4 sm:grid-cols-2">
        <input required value={form.name} onChange={set("name")} placeholder="نام و نام خانوادگی *" className={inputCls} data-testid="consult-name-input" />
        <input required value={form.phone} onChange={set("phone")} placeholder="شماره تماس (واتساپ) *" dir="ltr" className={`${inputCls} text-left`} data-testid="consult-phone-input" />
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        <input type="email" value={form.email} onChange={set("email")} placeholder="ایمیل (اختیاری)" dir="ltr" className={`${inputCls} text-left`} data-testid="consult-email-input" />
        <select value={form.country} onChange={set("country")} className={inputCls} data-testid="consult-country-select">
          {COUNTRIES.map((c) => <option key={c} value={c} className="bg-navy-900">{c}</option>)}
        </select>
      </div>
      <select value={form.visaType} onChange={set("visaType")} className={inputCls} data-testid="consult-visa-select">
        {VISA_TYPES.map((v) => <option key={v} value={v} className="bg-navy-900">{v}</option>)}
      </select>
      <textarea value={form.message} onChange={set("message")} rows={4} placeholder="شرح شرایط خود را بنویسید (تحصیلات، سابقه کار، سوالات...)" className={inputCls} data-testid="consult-message-input" />
      <button type="submit" disabled={loading} className="btn-gold w-full disabled:opacity-60" data-testid="consult-submit-button">
        {loading ? <Loader2 size={17} className="animate-spin" /> : <Send size={16} />}
        {loading ? "در حال ارسال..." : "ثبت درخواست مشاوره رایگان"}
      </button>
      <p className="text-center text-xs leading-6 text-slate-500">اطلاعات شما محرمانه است و فقط برای تماس کارشناسان گروه ۷ استفاده می‌شود.</p>
    </form>
  );
}
